/* ============================================================
 * Submit the form after changing the field
 *
 *
 * @author: David Pocina <dpocina[at]zerogrey[dot]com>
 *
 * ============================================================ */

(function ($) {
  'use strict'

  const selector = '[data-zg-role="submit-on-change"]'

  $(document).on('change.zg.submitOnChange', selector, function () {
    const $this = $(this)

    if ($this.val()) {
      $this
				.closest('form')
				.submit()

      // Stop the user from doing stuff while the page reloads.
      // Has to be done after submitting the form or the field won't be sent.
      $this.prop('disabled', true)
    }
  })
})(jQuery)
